import { QueryClient } from "@tanstack/react-query";
import { logger } from "@/lib/logger";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 10 * 60_000,
      retry: 2,
      refetchOnWindowFocus: false,
    },
    mutations: {
      onError: (error) => {
        logger.error("mutation_failed", { error: String(error) });
      },
    },
  },
});
